(() => { 
  const VariantStatusItemsLeft = ($productForm, variant) => {
    let variant_metafields = variant.metafields;

    let $itemsLeft = $productForm.find('.items_left_custom');

    if (window.PXUTheme.theme_settings.display_inventory_left) {
      let items_left_text = '';
      if (variant.inventory_quantity > 0) {
        items_left_text = window.PXUTheme.translation.one_item_left;
      }
      else {
        if (variant.inventory_policy == 'continue') {
          if (variant_metafields.stockmsg) {
            items_left_text = variant_metafields.stockmsg;
          }
          else { 
            items_left_text = window.PXUTheme.translation.items_left_text;
          }
        }
        else {
          items_left_text = '';
        } 
      }
      if (items_left_text != '') {
        items_left_text = `${items_left_text}`;
      }

      $itemsLeft.html(items_left_text);
    }
  }

 const VariantCrossSells = ($productForm, variant) => {
    let variant_metafields = variant.metafields;
    let $variantCrossSell = $productForm.find('.variant-crossell');
    let cross_sell_html = (variant_metafields.addon_sell) ? variant_metafields.addon_sell : '';

    // Clear the container first to prevent duplication
    $variantCrossSell.empty();

    // Inject the new HTML content
    $variantCrossSell.html(cross_sell_html);

    // Process all buttons within the cross-sell area
    $variantCrossSell.find('.addonbutton').each(function () {
        let $button = $(this);

        // Extract the clean text content
        let plainText = $button.find('span').length
            ? $button.find('span').text().trim() // Use text inside <span> if it exists
            : $button.text().trim(); // Otherwise, use raw button text

        // Clear the button content
        $button.empty();

        // Rebuild the button with sanitized content
        $button.append(`<span>${plainText}</span>`);
        $button.append(`
          <svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark">
            <path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path>
          </svg>
        `);
    });
};

  const VariantInternalDiam = ($productForm, variant) => {
    let variant_metafields = variant.metafields;
    let $variantInternalDiam = $productForm.find('.variant-internal-diam');
    let internal_diam = (variant_metafields.internal_diam) ? variant_metafields.internal_diam : '';
    $variantInternalDiam.html(internal_diam);
  }

  const VariantPromoMessage = ($productForm, variant) => {
    let variant_metafields = variant.metafields;
    let $variantPromoMessage = $productForm.find('.variant-promo-message');
    let promo_message = (variant_metafields.promo_message) ? variant_metafields.promo_message : '';
    $variantPromoMessage.html(promo_message);
  }

  const VariantAddonSell = ($productForm, variant) => {
    let variant_metafields = variant.metafields;
    let $variantAddonSell = $productForm.find('.variant-addon-sell');
    let addon_sell = (variant_metafields.addon_sell) ? variant_metafields.addon_sell : '';
    $variantAddonSell.html(addon_sell);
  }
  
  const CartPermalinkAjax = () => {
    $(document).on('click', '.addonbutton', function (e) {
      e.preventDefault();
      let $btn = $(e.currentTarget);
      var permalink = $btn.attr('href');

      $btn.addClass('active');
      
      $.get(permalink).then(function (response) {
        setTimeout(() => { 
          $btn.removeClass('active');
        }, 500);
        
        var isCartPage = $('body').hasClass('cart');
        if (isCartPage) {
          window.location.reload();
        }
        //console.log(response);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    });
  }

  let CovetPicsAddToCartEventHandler = () => {
    document.addEventListener('addToCart:covetPics', function(e) {  		
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  const DOMReady = () => {
    CartPermalinkAjax();
    CovetPicsAddToCartEventHandler();
  }
  
  document.addEventListener('variant:change', (e) => {
    let detail = e.detail;
    let $productForm = detail.$productForm;
    let variant = detail.variant;
    let product_id = detail.selector.product.id;
    let _product = window.products.find(p => p.id == product_id);
    let _variant = _product.variants.find(v => v.id == variant.id);

    VariantStatusItemsLeft($productForm, _variant);
    VariantCrossSells($productForm, _variant);
    VariantInternalDiam($productForm, _variant);
    VariantPromoMessage($productForm, _variant);
    VariantAddonSell($productForm, _variant);
  });

  document.addEventListener('DOMContentLoaded', (e) => { 
    DOMReady();
  });
})();

// Check if the current page is the cart page
function isCartPage() {
  return window.location.pathname === '/cart'; // Update this path if your cart URL differs
}

// Function to add checkmarks to addon buttons on the cart page
function addCheckmarksToAddonButtons() {
  // Select elements with the class .addonbutton on the Shopify cart page
  const addonButtons = document.querySelectorAll('.addonbutton');

  // SVG icon markup
  const svgIcon = `<svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark"><path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path></svg>`;

  // Loop through each .addonbutton element and modify it
  addonButtons.forEach(function(button) {
    // Wrap the existing text content with a span
    button.innerHTML = `<span>${button.textContent}</span>`;

    // Append the SVG icon
    button.insertAdjacentHTML('beforeend', svgIcon);
  });
}

// Execute the script only if it's the cart page
if (isCartPage()) {
  addCheckmarksToAddonButtons();
}

// Function to open video modal on product pages
function openModal() {
            var modal = document.getElementById('videoModal');
            modal.style.display = 'block';

            var video = document.getElementById('hortVideo');
            video.play();
        }

        function closeModal() {
            var modal = document.getElementById('videoModal');
            modal.style.display = 'none';

            var video = document.getElementById('hortVideo');
            video.pause();
            video.currentTime = 0;
        }

// Function to open tabbed content on mobile
document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".dsgn-pck__tab-title--mobile-stacked");
    const headerOffset = 50; // Adjust this value based on your sticky header height

    tabButtons.forEach(button => {
        button.addEventListener("click", function () {
            const tabId = this.getAttribute("data-dsgn-pck-tab");
            const panel = document.querySelector(`#DP--${tabId}`);

            if (panel) {
                // Wait for the panel to expand before scrolling
                setTimeout(() => {
                    const tabPosition = this.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({ top: tabPosition - headerOffset, behavior: "smooth" });
                }, 100);
            }
        });
    });
});

// Function to reset gallery to show first image on product page load
document.addEventListener('DOMContentLoaded', function () {

  // Only run on product pages, and not when a variant is specified in the URL
  if (!document.querySelector('.product_gallery')) return;
  if (new URLSearchParams(window.location.search).has('variant')) return;

  // Poll until Flickity has initialised on the gallery, then reset to slide 0
  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;

    var galleryEl = document.querySelector('.product_gallery');
    var flkty = galleryEl && typeof Flickity !== 'undefined' && Flickity.data(galleryEl);

    if (flkty || attempts > 40) {
      clearInterval(interval);
      if (flkty) {
        flkty.select(0, false, true);

        // Also reset the thumbnail nav if present
        var navEl = document.querySelector('.product_gallery_nav');
        var flktyNav = navEl && Flickity.data(navEl);
        if (flktyNav) flktyNav.select(0, false, true);
      }
    }
  }, 50);

});